
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-step");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/step/index.js
// module id = 1FaW
// module chunks = 6